import './typography.module.scss';
import MaterialTypography from '@mui/material/Typography';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    subtitle3: React.CSSProperties;
    subtitle4: React.CSSProperties;
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
    body6: React.CSSProperties;
    body7: React.CSSProperties;
    body8: React.CSSProperties;
    body9: React.CSSProperties;
    h2Toolbar: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subtitle3: true;
    subtitle4: true;
    body3: true;
    body4: true;
    body5: true;
    body6: true;
    body7: true;
    body8: true;
    body9: true;
    h2Toolbar: true;
  }
}

/* eslint-disable-next-line */
export interface TypographyProps {
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right',
  children?: any,
  // classes?: object,
  component?: any,
  gutterBottom?: boolean,
  noWrap?: boolean,
  paragraph?: boolean,
  variant?: 'body1' | 'body2' | 'body3' | 'body4' | 'body5' | 'body6' | 'body7' | 'body8' | 'body9' | 'button' | 'caption' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'inherit' | 'overline' | 'subtitle1' | 'subtitle2' | 'subtitle3' | 'subtitle4' | 'h2Toolbar',
  // variantMapping?: object,
  className?: string,
  sx?: any,
  title?: string,
  ['data-testid']?: string
}

export function Typography(props: TypographyProps) {
  return (
    <MaterialTypography
      align={props.align}
      component={props.component}
      gutterBottom={props.gutterBottom}
      paragraph={props.paragraph}
      variant={props.variant}
      className={props.className}
      sx={props.sx}
      noWrap={props.noWrap}
      title={props.title}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialTypography>
  );
}

export default Typography;